<template>
  <div>
    <div class="tab">
    	<div class="checkbox-container yellow">
    		<input
          type="checkbox"
          checked id="toggle"
          v-on:click="toggleCountryRegion()"
          />
    		<label for="toggle">
          <div v-if="byCountry" class="country-label">
            Country
          </div>
          <div v-else class="region-label">
            Region
          </div>
        </label>
    		<div class="active-circle"></div>
    	</div>
      <a
        v-if="windowWidth>656"
        id="private"
        style="float:right"
        class="tab-btn button6"
        :class="{'tab-btn-active': byPrivate}"
        v-on:click="setPublicPrivate('private')"
        >
          Private Funding
      </a>
      <a
        v-if="windowWidth>656"
        id="public"
        style="float:right"
        v-on:click="setPublicPrivate('public')"
        :class="{'tab-btn-active': byPublic}"
        class="tab-btn button6">
          Public Funding
      </a>
    </div>
    <div
        id="map"
        :style="'height: '+mapHeight"
        ref="mapElement"
        @mouseover="mouseOverMap = true"
        @mouseleave="mouseOverMap = false"
      >
      <div
        class="info leaflet-control-container leaflet-top leaflet-right"
        style="padding: 20px;"
        v-if="selectedCountry.name == null && mouseOverMap">
        Click on a country to see its stats. Data available for select countries only.
      </div>
    </div>
    <div style="height: 60px; padding: 10px; width:100%">
      <div style="margin: auto; width: 300px;">
      <a
        v-if="windowWidth<656"
        id="private"
        class="cent-btn button6"
        :class="{'cent-btn-active': byPrivate}"
        v-on:click="setPublicPrivate('private')"
        >
          Private Funding
      </a>
      <a
        v-if="windowWidth<656"
        id="public"
        v-on:click="setPublicPrivate('public')"
        :class="{'cent-btn-active': byPublic}"
        class="cent-btn button6">
          Public Funding
      </a>
      </div>
    </div>
  </div>
</template>

<script>

import geoJsonData from '@/assets/custom.geo.json.js'
import fundingData from '@/assets/fundingData.js'
import { mapGetters, mapActions, mapMutations } from "vuex";
import L from 'leaflet'

const maxes = {
  'maxCountryPublic': 30277754,
  'maxCountryPrivate': 16243164,
  'maxCountry': 30277754,
  'maxRegionPublic': 302805926,
  'maxRegionPrivate': 180682027,
  'maxRegion': 302805926
}

export default {
  name: 'country-chart',
  data() {
    return {
      map: null,
      geoJsonLayer: null,
      info: null,
      selectedCountry: {
        e: null,
        name: null,
        number: null,
        public: null,
        private: null,
        total: null,
      },
      byCountry: true,
      byRegion: false,
      byPrivate: false,
      byPublic: true,
      maxCurTotalByCountry: null,
      maxCurTotalByRegion: null,
      maxProviderNum: null,
      maxCurByPrivate: null,
      maxCurByPublic: null,
      mouseOverMap: false,
      countryLegend: null,
      windowWidth: window.innerWidth,
      mapHeight: null
    };
  },
  created() {
    var w = window.innerWidth;
    if(w <= 500) {
      this.mapHeight = '60vh'
      var view = [39.74739, -5]
      var multiplyer = 0.4
    } else if (w >= 1000) {
      this.mapHeight = '100vh'
      var view = [39.74739, -5]
      var multiplyer = 1.7
    } else if (w >= 700) {
      this.mapHeight = '90vh'
      var view = [39.74739, -5]
      var multiplyer = 1.5
    } else {
      this.mapHeight = '80vh'
      var view = [39.74739, -5]
      var multiplyer = 1
    }
  },
  mounted() {

    this.getProviderData();
    this.initMap();
    // this.initLayers();
  },
  computed: {
    ...mapGetters([
      'devCountries'
    ])
  },
  methods: {
    ...mapMutations([
      'setCapitalTypesParam',
      'setProviderTypesParam',
      'setCountriesParam',
      'setSectorsParam',
      'toggleCapitalTypesParam',
      'toggleProviderTypesParam',
      'toggleCountriesParam',
      'toggleSectorsParam'
    ]),
    ...mapActions({
      search: "search",
    }),
    navToDirectory(code){
      this.setSectorsParam()
      this.setProviderTypesParam()
      this.setCapitalTypesParam()
      this.setCountriesParam({code: code})
      var timeBefore = performance.now();
      this.search().then();
      this.$router.push({ name: 'Directory' })
    },
    getProviderData(){
      geoJsonData.features
        .forEach(feature=>{
          var data = fundingData[feature.properties.iso_a2]
          if (data) {
            feature.properties.number=data.number ? data.number : 0
            feature.properties.public=data.public ? data.public : 0
            feature.properties.private=data.private ? data.private: 0
            feature.properties.total
              = feature.properties.public
              + feature.properties.private

            feature.properties.region=data.region

            feature.properties.regionPublic=data.regionPublic ? data.regionPublic : 0
            feature.properties.regionPrivate=data.regionPrivate ? data.regionPrivate: 0
            feature.properties.regionTotal
              = feature.properties.regionPublic
              + feature.properties.regionPrivate

          }
        })
    },
    toggleCountryRegion(){
      this.byCountry = !this.byCountry
      this.byRegion = !this.byRegion
      this.rebuildMap()
    },
    rebuildMap(){
      this.map.off();
      this.map.remove();
      this.getProviderData();
      this.initMap();
      // this.initLayers();
    },
    setPublicPrivate(state){
      if(state == 'public') {
        this.byPublic = !this.byPublic
      } else if (state == 'private') {
        this.byPrivate = !this.byPrivate
      }
      this.rebuildMap()
    },
    highlightFeature(e) {
      var countryCode = e.target.feature.properties.iso_a2
      var developing = this.devCountries.some((c)=>c.code == countryCode)
      var layer = e.target;
      if (developing) {
        layer.setStyle({
          weight: 0.9,
          color: '#666',
          dashArray: '',
          fillOpacity: 1
        });

        if (!L.Browser.ie && !L.Browser.opera && !L.Browser.edge) {
          layer.bringToFront();
        }
      }
    },
    resetHighlight(e) {
      if (!this.selectedCountry.e) {
        this.geoJsonLayer.resetStyle(e.target);
      } else if (this.selectedCountry.e && e.target != this.selectedCountry.e.target) {
        this.geoJsonLayer.resetStyle(e.target);
      }
    },
    selectFeature(e) {
      var countryCode = e.target.feature.properties.iso_a2
      var developing = this.devCountries.some((c)=>c.code == countryCode)
      if (developing) {
        if (this.countryLegend != null) {
          L.DomUtil.remove(this.countryLegend)
        }
        var vm = this;
        var mainMenu = L.Control.extend({
          options: {position: 'topright'},
          onAdd : function (map) {
            if (developing){
              this._div = L.DomUtil.create('div', 'mainMenu');
              if (!L.Browser.touch) {
                L.DomEvent
                .disableClickPropagation(this._div)
                .disableScrollPropagation(this._div);
              } else {
                L.DomEvent.on(this._div, 'click', (_)=>{
                  L.DomEvent.stopPropagation
                  vm.navToDirectory(countryCode)
                });
              }

              this._div.innerHTML =  generateLegendHtml(
                e.target.feature.properties,
                developing,
                vm.byRegion
              );
              vm.countryLegend = this._div
              return this._div;

            }
          },
        });
        this.map.addControl(new mainMenu());

        var layer = e.target;

        if (this.selectedCountry.e && e.target != this.selectedCountry.e.target) {
          this.geoJsonLayer.resetStyle(this.selectedCountry.e.target);
        }

        layer.setStyle({
          weight: 0.9,
          color: '#666',
          dashArray: '',
          fillOpacity: 1
        });

        if (!L.Browser.ie && !L.Browser.opera && !L.Browser.edge) {
          layer.bringToFront();
        }

        this.selectedCountry.e = e
        this.selectedCountry.name = layer.feature.properties.name
        this.selectedCountry.number = layer.feature.properties.number
        this.selectedCountry.public = layer.feature.properties.public
        this.selectedCountry.private = layer.feature.properties.private
        this.selectedCountry.total = layer.feature.properties.total
      }
    },
    onEachFeature(feature, layer) {
    	layer.on({
        mouseover: this.highlightFeature,
    		mouseout: this.resetHighlight,
    		click: this.selectFeature
    	});
    },
    initMap() {
      var w = window.innerWidth;
      if(w <= 500) {
        var view = [39.74739, -5]
        var multiplyer = 0.4
      } else if (w >= 1000) {
        var view = [39.74739, -5]
        var multiplyer = 1.7
      } else if (w >= 700) {
        var view = [39.74739, -5]
        var multiplyer = 1.5
      } else {
        var view = [39.74739, -5]
        var multiplyer = 1
      }
      this.map = L.map(
        this.$refs['mapElement'],
        {
          zoomControl: false,
          zoomSnap: 0.25
        }).setView(view, multiplyer);

      this.geoJsonLayer = L.geoJson(geoJsonData, {
        clickable: false,
        style: this.style,
        onEachFeature: this.onEachFeature
      }).addTo(this.map);

      this.map.dragging.disable();
      this.map.touchZoom.disable();
      this.map.doubleClickZoom.disable();
      this.map.scrollWheelZoom.disable();

      if(this.selectedCountry.e) {
        e.target.setStyle({
          weight: 0.9,
          color: '#666',
          dashArray: '',
          fillOpacity: 1
        });

        if (!L.Browser.ie && !L.Browser.opera && !L.Browser.edge) {
          e.target.bringToFront();
        }
      }
    },
    // initLayers() {},
    getColor(d) {
      if (!this.byPrivate && !this.byPublic) {
        return '#ffffff'
      } else if (this.byRegion) {
        var normD = d/maxes.maxRegion
        return normD > 0.8 ? '#3bc5cf' :
          normD > 0.6  ? '#6acfd7' :
          normD > 0.4  ? '#8dd9df' :
          normD > 0.3  ? '#ace2e7' :
          normD > 0.15 ? '#c9ecef' :
          normD > 0.1  ? '#e4f6f7' :
          normD > 0.05 ? '#ffffff' :
                         '#ffffff';
      } else if (this.byCountry) {
        var normD = d/maxes.maxCountry
        return normD > 0.8 ? '#3bc5cf' :
          normD > 0.6  ? '#6acfd7' :
          normD > 0.4  ? '#8dd9df' :
          normD > 0.3  ? '#ace2e7' :
          normD > 0.15 ? '#c9ecef' :
          normD > 0.1  ? '#e4f6f7' :
          normD > 0.05 ? '#ffffff' :
                         '#ffffff';
      }
    },
    style(feature) {
      var value;
      if (this.byCountry) {
        if (this.byPublic && this.byPrivate) {
          value = feature.properties.total
        } else if (this.byPrivate) {
          value = feature.properties.private
        } else if (this.byPublic) {
          value = feature.properties.public
        } else {
          value = feature.properties.number
        }
      } else if (this.byRegion) {
        if (this.byPublic && this.byPrivate) {
          value = feature.properties.regionTotal
        } else if (this.byPrivate) {
          value = feature.properties.regionPrivate
        } else if (this.byPublic) {
          value = feature.properties.regionPublic
        } else {
          value = feature.properties.number
        }
      }

      return {
        fillColor: this.getColor(value),
        weight: 0.5,
        opacity: 1,
        color: 'grey',
        fillOpacity: 1
      };
    }
  },
}

function formatCurrency(val){
  return val.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
}

function generateLegendHtml(selectedCountry, developing, region){
  var title = selectedCountry.region
  var publicFunding;
  var privateFunding;
  var totalFunding;
  if (region) {
    if (selectedCountry.region == undefined) {
      title=selectedCountry.continent
    } else {
      title = selectedCountry.region
    }
    publicFunding = selectedCountry.regionPublic;
    privateFunding = selectedCountry.regionPrivate;
    totalFunding = selectedCountry.regionTotal;
  } else {
    title = selectedCountry.name
    publicFunding = selectedCountry.public;
    privateFunding = selectedCountry.private;
    totalFunding = selectedCountry.total;
  }
  return `<div
    class="info"
    style="
      margin: 6px 6px;
      padding: 6px 8px;
      font: 14px/16px Arial, Helvetica, sans-serif;
      background: white;
      color: black;
      text-align: left;
      background: rgba(255,255,255,0.8);
      box-shadow: 0 0 15px rgba(0,0,0,0.2);
      border-radius: 5px;
    "
    >
    <h4>${ title } Stats</h4>
    ${publicFunding>0?`<span><br>Public: $${ formatCurrency(publicFunding) }</span>`: ''}
    ${privateFunding>0?`<span><br>Private: $${ formatCurrency(privateFunding) }</span>`: ''}
    ${totalFunding>0?`<span><br>Total: $${ formatCurrency(totalFunding) }</span>`: ''}
    <br>
    <br>
    ${ developing && !region ?
      '<a id="link" style="cursor: pointer;"> Click here to see <br>these ' + selectedCountry.number + ' funders </a>'
      : ''}
  </div>`
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  #map {
    /* background-color: #3BC5CF; */
    background-color: white;
    height: 100vh;
    width: 100vw;
    margin: auto;
    position: relative;
  }

  .tab {
    border-bottom: 1px solid black;
    background-color: white;
    padding-left: 15vw;
    padding-right: 15vw;
    padding-top: 3px;
    height: 50px;
    margin: auto;
    position: relative;
  }

  .cent-btn {
    cursor: pointer;
    padding:0.7em 1.4em;
    margin: auto;
    display:inline-block;
    border-radius:4em;
    /* border-radius: 50%; */
    box-sizing: border-box;
    text-decoration:none;
    color: white;
    background-color: #3bc5cf;
    box-shadow:inset 0 -0.6em 0 -0.35em rgba(0,0,0,0.17);
    /* position:relative; */
    font-size: 15px;
  }

  .cent-btn-active {
    background-color: #36a1a9;
    top: 0.1em;
  }

  .tab-btn {
    cursor: pointer;
    padding:0.7em 1.4em;
    margin:0 0.3em 0.3em 0;
    border-radius:4em;
    /* border-radius: 50%; */
    box-sizing: border-box;
    text-decoration:none;
    color: white;
    background-color: #3bc5cf;
    box-shadow:inset 0 -0.6em 0 -0.35em rgba(0,0,0,0.17);
    position:relative;
    font-size: 15px;
  }

  .tab-btn-active {
    background-color: #36a1a9;
    top: 0.1em;
  }

  /* Create an active/current tablink class */

  .info {
    margin: 6px 6px;
    padding: 6px 8px;
    font: 14px/16px Arial, Helvetica, sans-serif;
    background: white;
    color: black;
    text-align: left;
    background: rgba(255,255,255,0.8);
    box-shadow: 0 0 15px rgba(0,0,0,0.2);
    border-radius: 5px;
  }

  .info h4 {
    margin: 0 0 0 0px;
    color: #777;
  }

  .country-label {
    color: white;
    padding:0.7em 1.4em;
    font-size: 15px;
    font-weight: 400;
  }

  .region-label {
    color: white;
    padding:0.7em 5.4em;
    font-size: 15px;
    font-weight: 400;
  }

  .checkbox-container {
  	display: inline-block;
  	position: relative;
    float: right;
  }

  .checkbox-container label {
  	background-color: #3bc5cf;
  	border-radius: 20px;
  	display: inline-block;
  	position: relative;
  	transition: all 0.3s ease-out;
  	width: 145px;
  	height: 43px;
  	z-index: 2;

    background-color: #3bc5cf;
    box-shadow:inset 0 -0.6em 0 -0.35em rgba(0,0,0,0.17);
  }

  .checkbox-container label::after {
  	content: ' ';
  	background-color: white;
  	border-radius: 50%;
  	position: absolute;
  	top: 1px;
  	left: 2px;
  	transform: translateX(0);
  	transition: transform 0.3s linear;
  	width: 38px;
  	height: 36px;
  	z-index: 3;
  }

  .checkbox-container input {
  	visibility: hidden;
  	position: absolute;
  	z-index: 2;
  }

  .checkbox-container input:checked + label::after {
  	transform: translateX(calc(270% + 0.5px));
  }

  .active-circle {
  	border-radius: 50%;
  	position: absolute;
  	top: 50%;
  	left: 50%;
  	transform: translate(calc(-50% - 10px), calc(-50% - 2px)) scale(0);
  	transition: transform 0.6s ease-out;
  	width: 30px;
  	height: 30px;
  	z-index: 1;
  }

</style>



// WEBPACK FOOTER //
// src/elements/charts/CountryChart.vue